import styled from 'styled-components';

export const Container = styled.div`
  .product-not-available span {
    color: var(--red);
    font-size: 1.7rem;
    font-weight: 700;
    text-transform: uppercase;
  }

  .product-not-available button {
    font-size: 1rem;
    width: max-content;
    padding: 1rem 4.3rem;
    margin: 2rem 0;
    border-radius: 0.4rem;
    background-color: var(--blue);
    border: 2px solid var(--blue);
  }

  .product-not-available button:hover {
    background-color: var(--blue);
    color: var(--white);
    opacity: 0.7;
  }

  .pdp-details .navigation-pages,
  .pdp-details .product {
    padding: 2rem 1rem;
  }

  @media (max-width: 768px) {
    .pdp-details .navigation-pages,
    .pdp-details .product {
      margin: 0 1rem;
    }

    .pdp-details .product {
      margin: 1rem;
      padding: 1rem;
      width: auto;
    }

    .navigation-pages {
      display: none;
    }

    .modal-send-recipe {
      .modal-container {
        min-width: inherit;
      }

      .group-items {
        flex-direction: column;
      }

      .group-items.inputs-radio {
        flex-direction: row;
      }
    }
  }
`;
